import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";
import { LogoMark } from "./Logo";
import { NaturAirText } from "./NaturAirText";

export const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" data-testid="about-section" className="relative py-28 sm:py-36 bg-[#050505]">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <Eyebrow>{t.about_eyebrow}</Eyebrow>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F3E5AB] leading-tight">{t.about_title}</h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-14 flex flex-col items-center">
            <div className="w-24 h-24 rounded-full border border-[rgba(197,160,89,0.45)] bg-[#0C0C0C] flex items-center justify-center shadow-[0_0_60px_rgba(197,160,89,0.12)]">
              <LogoMark size={52} />
            </div>
            <h3 data-testid="about-founder-name" className="mt-6 font-serif text-2xl gold-text">{t.about_name}</h3>
            <p data-testid="about-founder-experience" className="mt-2 text-[11px] tracking-[0.3em] uppercase text-[#8A8270]">
              {t.about_role}
            </p>
          </div>
        </Reveal>

        <div className="mt-12 space-y-7 max-w-3xl mx-auto">
          {[t.about_p1, t.about_p2, t.about_p3, t.about_p4].map((p, i) => (
            <Reveal key={i} delay={0.12 + i * 0.08}>
              <p className="text-[#C7BFA7] font-light leading-loose text-base sm:text-lg border-s border-[rgba(197,160,89,0.35)] ps-6">
                {i === 3 ? <NaturAirText text={p} testid="about-p4" /> : p}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
